import React from 'react';
import { useParams } from 'react-router-dom';
import * as permissionKind from '../../../../shared/permissions';
import { useGetCompanyQuery } from '../../../api/queries/getCompany';
import { useAccount } from '../../../components/contexts/AccountContextManager';
import { useCompany } from '../../../components/contexts/CompanyContextManager';
import LoadingElement from '../../../components/LoadingElement';
import NotFoundResult from '../../../components/results/NotFoundResult';
import hasPermissions from '../../../utilities/hasPermissions';
import CompanyDetailsInnerPage from './CompanyDetailsInnerPage';

const CompanyDetailsPage = () => {
    const { companyId } = useParams<{ companyId: string }>();

    const { data, loading } = useGetCompanyQuery({
        fetchPolicy: 'network-only',
        variables: { id: companyId },
    });

    const companyContext = useCompany(true);
    const { permissions: accountPermissions } = useAccount();

    const hasPermission = companyContext
        ? hasPermissions(companyContext.permissions, [permissionKind.viewCompanies]) &&
          hasPermissions(accountPermissions, [permissionKind.viewCompanies])
        : hasPermissions(accountPermissions, [permissionKind.viewCompanies]);

    const company = data?.company;

    if (!company && loading) {
        return <LoadingElement />;
    }
    if (!company || !hasPermission) {
        return <NotFoundResult />;
    }

    return <CompanyDetailsInnerPage company={company} />;
};

export default CompanyDetailsPage;
